
import { useState, useEffect } from 'react';
import { Story } from '@/types/content';

// Sample initial stories data
const initialStories: Story[] = [
  {
    id: 1,
    title: "New Dental Implant Technique",
    image: "https://images.unsplash.com/photo-1588776814546-1ffcf47267a5?w=500&h=280&auto=format&fit=crop",
    description: "Check out the new dental implant technique we're using that reduces recovery time by 50%!",
    views: 142,
    likes: 38,
    createdAt: new Date(Date.now() - 12 * 60 * 60 * 1000),
    expiresAt: new Date(Date.now() + 12 * 60 * 60 * 1000),
    isPublic: true
  },
  {
    id: 2,
    title: "Office Tour",
    image: "https://images.unsplash.com/photo-1629909613654-28e377c37b09?w=500&h=280&auto=format&fit=crop",
    description: "Take a virtual tour of our newly renovated office space with state-of-the-art equipment.",
    views: 89,
    likes: 22,
    createdAt: new Date(Date.now() - 36 * 60 * 60 * 1000),
    expiresAt: new Date(Date.now() - 12 * 60 * 60 * 1000),
    isPublic: true
  },
  {
    id: 3,
    title: "Teeth Whitening Special",
    image: "https://images.unsplash.com/photo-1581585195376-43a72f85c0b6?w=500&h=280&auto=format&fit=crop",
    description: "Limited time offer: 20% off professional teeth whitening treatments this month!",
    views: 203,
    likes: 57,
    createdAt: new Date(Date.now() - 24 * 60 * 60 * 1000),
    expiresAt: new Date(Date.now() + 8 * 60 * 60 * 1000),
    isPublic: true
  }
];

export const useStoriesManagement = () => {
  const [stories, setStories] = useState<Story[]>(initialStories);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  // Add a new story
  const addStory = (story: Story) => {
    setStories(prevStories => [story, ...prevStories]);
  };

  // Delete a story
  const deleteStory = (storyId: number) => {
    setStories(prevStories => prevStories.filter(story => story.id !== storyId));
  };

  // Toggle story visibility (public/private)
  const toggleVisibility = (storyId: number) => {
    setStories(prevStories => 
      prevStories.map(story => 
        story.id === storyId ? { ...story, isPublic: !story.isPublic } : story
      )
    );
  };

  // Extend story expiry by 24 hours
  const extendExpiry = (storyId: number) => {
    setStories(prevStories => 
      prevStories.map(story => {
        if (story.id === storyId) {
          const currentExpiry = new Date(story.expiresAt || Date.now());
          const newExpiry = new Date(currentExpiry.getTime() + 24 * 60 * 60 * 1000);
          return { ...story, expiresAt: newExpiry };
        }
        return story;
      })
    );
  };

  // In a real app, we would fetch stories from an API
  useEffect(() => {
    // Simulate API call
    setLoading(true);
    try {
      // In a real app, this would be a fetch call
      setTimeout(() => {
        setStories(initialStories);
        setLoading(false);
      }, 500);
    } catch (err) {
      setError("Failed to fetch stories");
      setLoading(false);
    }
  }, []);

  return {
    stories,
    loading,
    error,
    addStory,
    deleteStory,
    toggleVisibility,
    extendExpiry
  };
};
